import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ISolicitudAmpliacionSsoModel } from 'src/app/models/interfaces/calendario-sso/ISolicitudAmpliacionSsoModel';
import { DetalleSeguimientoPasstModel } from 'src/app/models/passt/SeguimientoPasstModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudAmpliacionSsoService } from 'src/app/services/solicitud-ampliacion-sso/solicitud-ampliacion-sso.service';
import { PasstActividadSolicitarEdicionDialogComponent } from '../passt-actividad-solicitar-edicion-dialog/passt-actividad-solicitar-edicion-dialog.component';
import { SolicitudAmpliacionSsoModel } from 'src/app/models/calendario-sso/SolicitudAmpliacionSsoModel';
import { NgForm } from '@angular/forms';
import { TipoSolicitudAmpliacion, eTypeResult } from 'src/app/models/common/enumModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';

@Component({
  templateUrl: './passt-solicitar-programacion-edicion-dialog.component.html',
  styleUrls: ['./passt-solicitar-programacion-edicion-dialog.component.css']
})
export class PasstSolicitarProgramacionEdicionDialogComponent implements OnInit {

  model:ISolicitudAmpliacionSsoModel;
  meses: Mes[] = [
    {value: '1', viewValue: 'Enero'},
    {value: '2', viewValue: 'Febrero'},
    {value: '3', viewValue: 'Marzo'},
    {value: '4', viewValue: 'Abril'},
    {value: '5', viewValue: 'Mayo'},
    {value: '6', viewValue: 'Junio'},
    {value: '7', viewValue: 'Julio'},
    {value: '8', viewValue: 'Agosto'},
    {value: '9', viewValue: 'Setiembre'},
    {value: '10', viewValue: 'Octubre'},
    {value: '11', viewValue: 'Noviembre'},
    {value: '12', viewValue: 'Diciembre'},
  ];
  constructor(public dialogRef: MatDialogRef<PasstActividadSolicitarEdicionDialogComponent>,
    private alertDialogService: AlertDialogService,
    private dialogService: ConfirmDialogService,
    @Inject(MAT_DIALOG_DATA) public data: DetalleSeguimientoPasstModel,
    private service: SolicitudAmpliacionSsoService) { 
      this.model = new SolicitudAmpliacionSsoModel();
      this.model.anio = data.anio;
      this.model.idSede = data.idSede;
      this.model.sede = data.sede;
    }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(form: NgForm) {
    
    if (!form.invalid) {      
      
      
      if (this.model.motivo == '') {
        this.alertDialogService.open('Debe ingresar el motivo de su solicitud');
      } else {
        this.dialogService.open('¿Seguro de enviar la solicitud?'); //options
          this.dialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {  
              this.model.idTipo = TipoSolicitudAmpliacion.ModificacionProgramacionPASST;
              if(this.model.mesSelected)
                this.model.mes = this.model.mesSelected;
              this.service.submit(this.model).subscribe((result: ActionResultModel) => {
                console.log(result);
                if(result.type!=eTypeResult.SUCCESS){
                  this.alertDialogService.open(result.message);
                }else{
                  this.dialogRef.close(this.data);
                }
              });
            }
          });
        
      }
    }
  }

}
interface Mes {
  value: string;
  viewValue: string;
}